import React, { Suspense, useEffect } from 'react'
import { Route, Switch, Redirect } from 'react-router'

import { useInfo } from '../common/hooks/useInfo'
import OauthComponent from '../modules/login/OauthComponent'
import Admin from './admin'
import Coordinator from './coordinator'
import EcommerceStudent from './ecommerceStudent'
import { DashboardLocation } from './locations/local/dashboard'
import Login from './login'
import Professor from './professor'
import Public from './public'
import { GuardedRoute } from './secure/components/GuardedRoute'
import { allowOnlyAdmin } from './secure/routeguards/allowOnlyAdmin'
import { allowOnlyCoordinator } from './secure/routeguards/allowOnlyCoordinator'
import { allowOnlyEcommerceStudent } from './secure/routeguards/allowOnlyEcommerceStudent'
import { allowOnlyLogged } from './secure/routeguards/allowOnlyLogged'
import { allowOnlyNotLogged } from './secure/routeguards/allowOnlyNotLogged'
import { allowOnlyProfessor } from './secure/routeguards/allowOnlyProfessor'
import { allowOnlyStudent } from './secure/routeguards/allowOnlyStudent'
import { allowOnlyStudents } from './secure/routeguards/allowOnlyStudents'
import { allowBloxCreation } from './secure/routeguards/permissions/allowBloxCreation'
import { allowBloxEdit } from './secure/routeguards/permissions/allowBloxEdit'
import { allowBloxList } from './secure/routeguards/permissions/allowBloxList'
import { allowBloxStatusEdit } from './secure/routeguards/permissions/allowBloxStatusEdit'
import { allowDashboard } from './secure/routeguards/permissions/allowDashboard'
import { allowDiscussionGroups } from './secure/routeguards/permissions/allowDiscussionGroups'
import { allowOfferings } from './secure/routeguards/permissions/allowOfferings'
import { allowStudentImpersonate } from './secure/routeguards/permissions/allowStudentImpersonate'
import { allowStudentsList } from './secure/routeguards/permissions/allowStudentsList'
import Student from './student'

const guards = {
  allowOnlyAdmin: allowOnlyAdmin,
  allowOnlyCoordinator: allowOnlyCoordinator,
  allowOnlyStudent: allowOnlyStudent,
  allowOnlyStudents: allowOnlyStudents,
  allowOnlyEcommerceStudent: allowOnlyEcommerceStudent,
  allowOnlyProfessor: allowOnlyProfessor,
  allowOnlyLogged: allowOnlyLogged,
  allowOnlyNotLogged: allowOnlyNotLogged,
  allowDashboard: allowDashboard,
  allowBloxCreation: allowBloxCreation,
  allowBloxEdit: allowBloxEdit,
  allowBloxList: allowBloxList,
  allowBloxStatusEdit: allowBloxStatusEdit,
  allowDiscussionGroups: allowDiscussionGroups,
  allowOfferings: allowOfferings,
  allowStudentImpersonate: allowStudentImpersonate,
  allowStudentsList: allowStudentsList,
}

const NotFoundComponent = React.lazy(() => import('../modules/error/NotFoundComponent'))

const Dashboard = () => {
  const [userInfo] = useInfo()
  let path

  if (!userInfo) {
    localStorage.clear()
  } else if (userInfo.data?.role?.includes('student') && userInfo.data.ecommerce_user) {
    path = '/ecommerce-student'
  } else {
    path = `/${userInfo.data.role}`
  }

  return <Redirect to={path} />
}

const renderRoutes = (entry) => {
  let response = []
  for (const item in entry) {
    entry[item].map((param) =>
      response.push(
        <GuardedRoute
          key={param.name}
          component={param.component}
          path={param.path}
          name={param.name}
          exact
          guards={param.guards && param.guards.map((guard) => guards[guard])}
          redirectTo={param.redirect || '/login'}
        />,
      ),
    )
  }
  return response
}

const Routes = () => {
  const compareVersions = (versionA, versionB) => {
    const versionsA = versionA.split(/\./g)

    const versionsB = versionB.split(/\./g)
    while (versionsA.length || versionsB.length) {
      const a = Number(versionsA.shift())

      const b = Number(versionsB.shift())

      if (a === b) continue

      return a > b || isNaN(b)
    }
    return false
  }

  useEffect(() => {
    fetch('/meta.json')
      .then((response) => response.json())
      .then((meta) => {
        const latestVersion = `${meta.version}`
        const currentVersion = `${localStorage.getItem('@blox:lastVersion')}`

        if (compareVersions(latestVersion, currentVersion)) {
          console.log(`We have a new version - ${latestVersion}. Refreshing.`)
          localStorage.setItem('@blox:lastVersion', latestVersion)
          if (caches) {
            caches.keys().then(function (names) {
              for (let name of names) caches.delete(name)
            })
          }
          window.location.reload(true)
        } else {
          console.log(`You already have the latest version - ${latestVersion}. No cache refresh needed.`)
        }
      })
  }, [])

  return (
    <Suspense fallback={<span />}>
      <Switch>
        <Route path='/oauth' exact component={OauthComponent} />
        <GuardedRoute
          component={Dashboard}
          path={DashboardLocation.path}
          exact
          guards={[allowOnlyLogged]}
          redirectTo={'/login'}
        />
        {renderRoutes(Login)}
        {renderRoutes(Admin)}
        {renderRoutes(Coordinator)}
        {renderRoutes(Student)}
        {renderRoutes(EcommerceStudent)}
        {renderRoutes(Professor)}
        {renderRoutes(Public)}

        <Route component={NotFoundComponent} />
      </Switch>
    </Suspense>
  )
}
export default Routes
